<script>

export default {
	name: 'Loader',
	props: [
		'current',
		'total',
		'error',
		'errorText'
	],
	computed: {
		// progress() {
		// 	if (!this.current || !this.total) return null;
		// 	return `${this.current} / ${this.total}`;
		// },
		// percent() {
		// 	if (!this.current || !this.total) return null;
		// 	return (100 / this.total) * this.current;
		// }
	}
};
</script>

<template>
	<div class="loaderOverlay">
		<div>
			<template v-if="errorText">
				<h5>{{ errorText }}</h5>
				<router-link class="loader__link" :to="{name: 'Locations'}">Choose different restaurant</router-link>
			</template>

			<img v-else class="spinner" :src="staticDir('/images/icons/icon-loader.svg')" alt="Loading...">

			<!-- <p v-if="progress">{{progress}}</p> -->
			<!-- <div v-if="percent"><span v-bind:style="{width: percent + '%'}"></span></div> -->
		</div>
	</div>
</template>



// WEBPACK FOOTER //
// src/vue/components/loader.vue